export default "__VITE_ASSET__DmysiVYe__"